import React from 'react';
export const Spinner = (props)=>{
    const { size =24 , color ='currentColor'  } = props;
    return /*#__PURE__*/ React.createElement("svg", {
        "data-testid": "spinner",
        fill: "none",
        height: size,
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: `0 0 ${size} ${size}`,
        width: size,
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("style", {
        type: "text/css"
    }, `
          .path {
            stroke-dasharray: 62.80738067626953px;
            animation: dash 0.4s linear infinite alternate;
          }

          @keyframes dash {
            from {
              stroke-dashoffset: 0;
            }
            to {
              stroke-dashoffset: 62.80738067626953px;
            }
          }
          `)), /*#__PURE__*/ React.createElement("path", {
        className: "path",
        d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
    }));
};

//# sourceMappingURL=spinner.js.map